export const RESET_COUNTER_NUMBER = 49;
